<template>
  <div class="toggle-label-row">
    <div class="label-left">
      <h3>ราคาจากสมาคมค้าทองคำ</h3>
      <span class="trader-price">{{barSellPrice}}</span>
      <span> ฿/บาททอง</span>
    </div>
    <div class="label-right" @click="toggle()" :data-action="dataAction" >
      <toggle-button :value="toggleAverage" :sync="true" color="#17c161" :height="toggleBox.height" :width="toggleBox.width" />
    </div>
  </div>
</template>
<script>
import { ToggleButton } from "vue-js-toggle-button"
import { formatCurrency } from "../../../utils/global"
export default {
  components: {
    ToggleButton
  },
  props: {
    price: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      toggleAverage: true,
      isToggle: false,
      toggleBox: {
        width: 45,
        height: 21
      },
      barSellPrice: 0.00
    }
  },
  watch: {
    toggleAverage: {
      immediate: true,
      handler(val) {
        this.$emit("toggle-average", val)
      }
    },
    price: {
      immediate: true,
      handler() {
        this.barSellPrice = this.price.data ? formatCurrency(this.price.data.barSellPrice, 'NONE', 2) : 0.00
      },
    }
  },
  computed: {
    dataAction() {
      return `toggle_${this.toggleAverage ? "off" : "on"}_gta_price`
    },
  },
  methods: {
    toggle() {
      this.toggleAverage = this.toggleAverage ? false : true
    }
  },
}
</script>
<style lang="scss" scoped>
.toggle-label-row {
  position: relative;
  padding: 8px 14px;
  min-height: 40px;
  border: solid 1px #f9f9f9;
  background-color: $color-white;
  .label-left {
    @include finCol(6, 12, 0px, middle, true, true);
    h3 {
      @extend %font-size-s;
      font-weight: bold;
      color: $color-normal-text;
    }
    p {
      margin: 0;
      @extend %font-size-ss;
      color: $color-normal-text;
    }
    span {
      margin: 0;
      @extend %font-size-ss;
      color: $color-normal-text;
    }
    .trader-price {
      font-weight: bold;
    }
  }
  .label-right {
    @include finCol(6, 12, 0px, middle, true, true);
    text-align: right;
    h2 {
      @extend %font-size-l;
      font-weight: bold;
      color: $color-normal-text;
    }
    p {
      margin: 0;
      @extend %font-size-ss;
      color: $color-normal-text;
    }
    label {
      pointer-events: none;
    }
  }
  &:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 6px;
    background-color: #bababa;
  }
}
</style>